/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
// import ExportButton from "../../../components/common/ExportButton/ExportButton";
import { Helmet } from "react-helmet";
import Toast from "../../../components/common/Toast";
import TransferTable from "../../../components/common/new/AccordianTable/TransferTable";
// import { VIEW_INTRO_COL } from "../../../contants/table/friendSearch";
import ToggleStructure from "../../../components/Header/ToggleStructure/ToggleStructure";
import {
  INTIATE_VIEW_INTRODUCTION_DATA,
  SET_PENDING_TRANSFER_TYPE,
  SET_SELECTED_INTRODUCTION,
} from "../../../redux/actionTypes/dashboard";
import IntroductionAPI from "../../../services/api/introductionForm";
// import { flattenObj } from "../../../utils/helper";
import Styles from "./styles";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import { Constants } from "../../../contants";
import { DEFAULT_TRANFER_TYPE } from "../../../redux/reducers/dashboard";
import { performOperation } from "../../member/MemberSearch/utils";
import { introductionLoading } from "../../../redux/selectors/introduction";
import Loader from "../../../components/common/Loader/Loader";

export default function ViewIntroduction() {
  const TITLE = "View Introduction - BSG";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showToast, setShowToast] = useState(null);
  const introductionData = useSelector((state) => state.view_introduction.data);
  // const dataForCSV = introductionData?.map((ele) => flattenObj(ele));
  const transferType = useSelector(
    (state) => state.dashboard.transferPendingType
  );
  const paginationInfo = useSelector(
    (store) => store.view_introduction.paginationInfo
  );

  const isLoading = useSelector(introductionLoading);

  const handleForward = (data) => {
    dispatch({
      type: SET_SELECTED_INTRODUCTION,
      payload: { ...data, id: data.introductionId },
    });
    navigate(`/introduction/view-remarks/forward/${data.introductionId}`);
  };

  const fetchIntroductionData = async (
    pageNumber = 0,
    pageSize = Constants.DEFAULT_PAGE_SIZE
  ) => {
    dispatch({
      type: INTIATE_VIEW_INTRODUCTION_DATA,
      payload: {
        type: transferType,
        pageNumber,
        pageSize,
      },
    });
  };

  const onPaginationClick = (pageNumber) => {
    const { pageSize } = paginationInfo;
    fetchIntroductionData(pageNumber, pageSize);
  };

  const onPageSizeClick = (operator) => {
    const { pageSize } = paginationInfo;
    const newPageSize = performOperation(
      pageSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    fetchIntroductionData(0, newPageSize);
  };

  const handleReject = (data) => {
    dispatch({
      type: SET_SELECTED_INTRODUCTION,
      payload: { ...data, id: data.introductionId },
    });
    // navigate(`/introduction/view-remarks/reject/${data.introductionId}`);
  };

  const handleRemarks = (data) => {
    dispatch({
      type: SET_SELECTED_INTRODUCTION,
      payload: { ...data, id: data.introductionId },
    });
    navigate(`/remarks/introduction/${data.introductionId}`);
  };

  const handleCancel = async (selectedIntro) => {
    try {
      await IntroductionAPI.cancelIntro({
        data: {
          introductionIds: [selectedIntro.introductionId],
        },
      });
      setShowToast({
        message: "Cancel Successfully",
        severity: "success",
      });
      fetchIntroductionData();
    } catch (error) {
      setShowToast({
        message: error.message,
        severity: "error",
      });
      Sentry.captureException(error);
    }
  };

  const onRadioChange = (evt) => {
    dispatch({
      type: SET_PENDING_TRANSFER_TYPE,
      payload: evt.target.value,
    });
  };

  useEffect(() => {
    fetchIntroductionData();
  }, [transferType]);

  useEffect(() => {
    // Reset Pending Transfer type
    return () =>
      dispatch({
        type: SET_PENDING_TRANSFER_TYPE,
        payload: DEFAULT_TRANFER_TYPE,
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div style={Styles.container}>
        {/* {loader || isLoading ? (
      <div style={Styles.divLoader}>loading data...</div>
    ) : (
      <> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: "1rem",
          }}
        >
          <Box style={Styles.left}>
            <Box style={Styles.radioContainer}>
              <ToggleStructure
                value={transferType}
                label="Introductions"
                handleChange={onRadioChange}
              />
            </Box>
          </Box>
          {/* <ExportButton
      data={dataForCSV}
      columnHeadingList={VIEW_INTRO_COL}
      fileName="introduction"
    /> */}
        </Box>
        <TransferTable
          data={introductionData}
          handleForward={handleForward}
          handleReject={handleReject}
          handleRemarks={handleRemarks}
          handleCancel={handleCancel}
        />
        {introductionData.length ? (
          <Box style={Styles.pagination}>
            <Pagination
              totalPages={paginationInfo.totalPages}
              totalResults={paginationInfo.totalElements}
              currentPage={paginationInfo.currentPage}
              pageSize={paginationInfo.pageSize}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          </Box>
        ) : (
          !isLoading && (
            <Box style={Styles.emptyContainer}>
              <h1 style={Styles.noDataMsg}>No Results</h1>
            </Box>
          )
        )}
        {isLoading && <Loader />}
        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => {
            setShowToast(null);
          }}
        />
        {/* </>
    )} */}
      </div>
    </>
  );
}
